// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kp1yZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported for benchmarkElement.ts
parcelHelpers.export(exports, "crosswordFilter", ()=>crosswordFilter);
parcelHelpers.export(exports, "CrosswordPageElement", ()=>CrosswordPageElement);
var _tsDecorate = require("@swc/helpers/_/_ts_decorate");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _form = require("../css/form");
var _reset = require("../css/reset");
var _stack = require("../css/stack");
var _type = require("../css/type");
var _decorators = require("../decorators");
var _util = require("../util");
var _wordList = require("../wordList");
var _wordListElement = require("../wordListElement");
function crosswordFilter(words, pattern) {
    // 'c.t' -> /^c[a-z]t$/
    const patternRe = new RegExp(`^${pattern.replace(/[^a-z]/g, "[a-z]")}$`);
    return words.filter((word)=>patternRe.test(word));
}
// Make everything that's not a letter turn into a hyphen.
const normalizePattern = (pattern)=>pattern.toLowerCase().replace(/[^a-z]/g, "-");
class CrosswordPageElement extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.pattern = "cr---w--d";
        this.words = [];
        this.limit = 1000 // don't render more than this many words at once
        ;
        this.rangeDescription = "" // "first 1000 of 2345"
        ;
        this.loading = true;
        this.updateResults();
    }
    updateResults() {
        this.loading = true;
        this.error = false;
        (0, _wordList.wordListPromise).then((wordList)=>{
            this.words = crosswordFilter(wordList, this.pattern);
        }, (reason)=>{
            this.words = [];
            this.error = reason;
        }).finally(()=>{
            this.loading = false;
            this.rangeDescription = (0, _util.makeRangeDescription)(this.words.length, this.limit);
        });
    }
    onPatternChange(event) {
        const target = event.target;
        this.pattern = normalizePattern(target.value);
        // A hack? to make sure the input's displayed value updates when the new
        // value undoes the change the user just made. Without this, the framework
        // sees "no change" and the user's change isn't undone.
        // https://github.com/Polymer/lit-element/issues/144#issuecomment-468098257
        target.value = this.pattern;
        this.updateResults();
    }
    static get styles() {
        return [
            (0, _reset.resetCss),
            (0, _stack.stackCss),
            (0, _type.typeCss),
            (0, _form.formCss)
        ];
    }
    render() {
        return (0, _lit.html)`
      <div class="stack">
        <p>Type in your progress, indicating unsolved letters with a <samp>-</samp> (hyphen).</p>

        <div>
          <label for="pattern">Your progress</label>
          <input
              id="pattern"
              class="puzzle-input"
              autofocus
              spellcheck="false"
              .value="${this.pattern}"
              @input="${this.onPatternChange}">
        </div>

        <div>
          <h2>See the ${this.pattern && this.rangeDescription} possible words</h2>

          ${this.loading ? (0, _lit.html)`<p>Loading&hellip;</p>` : null}

          ${this.error ? (0, _lit.html)`
          <p title="${JSON.stringify(this.error)}">
            Something&rsquo;s broken &mdash; we couldn't find your words.
          </p>
          ` : null}

          <mw-word-list .words="${this.words}" .limit="${this.limit}"></mw-word-list>
        </div>

        <div>
          <h3>About the results</h3>
          <p>
            The results are only English "dictionary" words, so they
            won't help you find crossword answers that are phrases,
            abbreviations, or proper nouns.
          </p>
          <p>
            The words come from the ENABLE word list (Y2K update), described at
            <a href="http://archive.aspell.net/enable2k">archive.aspell.net/enable2k</a>.
          </p>
        </div>
      </div>
    `;
    }
}
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], CrosswordPageElement.prototype, "pattern", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], CrosswordPageElement.prototype, "words", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], CrosswordPageElement.prototype, "rangeDescription", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], CrosswordPageElement.prototype, "loading", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], CrosswordPageElement.prototype, "error", void 0);
(0, _tsDecorate._)([
    (0, _decorators.debounce)(100)
], CrosswordPageElement.prototype, "updateResults", null);
CrosswordPageElement = (0, _tsDecorate._)([
    (0, _decoratorsJs.customElement)("mw-crossword-page")
], CrosswordPageElement);

},{"@swc/helpers/_/_ts_decorate":"3Z6vO","lit":"aCmte","lit/decorators.js":"kQrIl","../css/form":"8MMj0","../css/reset":"lBn3n","../css/stack":"812mT","../css/type":"9FxKK","../decorators":"d8Nql","../util":"93Cnt","../wordList":"5Ye1N","../wordListElement":"4NDBJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8Nql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Prints the runtime for the method every time it's called. */ parcelHelpers.export(exports, "time", ()=>time);
/** Returns a decorator that debounces the method with the given wait time. */ parcelHelpers.export(exports, "debounce", ()=>debounce);
var _debounce = require("./debounce");
function time(target, propertyKey, descriptor) {
    const originalFunction = descriptor.value;
    descriptor.value = function() {
        console.time(originalFunction.name);
        const returnValue = originalFunction.apply(this, arguments);
        console.timeEnd(originalFunction.name);
        return returnValue;
    };
}
function debounce(waitTimeMs) {
    return function debounceDecorator(target, propertyKey, descriptor) {
        descriptor.value = (0, _debounce.debounce)(descriptor.value, waitTimeMs, true);
    };
}

},{"./debounce":"3kfkg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kfkg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
function debounce(fn, waitMs, leading = false) {
    let timeoutId = null;
    function debounced(...args) {
        let fnThis = this;
        let fnArguments = arguments;
        if (timeoutId !== null) clearTimeout(timeoutId);
        if (leading && timeoutId === null) fn.apply(fnThis, fnArguments);
        timeoutId = window.setTimeout(()=>{
            fn.apply(fnThis, fnArguments);
            timeoutId = null;
        }, waitMs);
    }
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93Cnt":[function(require,module,exports) {
// Return a noun-phrase for the first `limit`-many of `quantity`-many items.
// For example: "345", "first 100 of 345".
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeRangeDescription", ()=>makeRangeDescription);
// Given an array of values, return a subsequence where only the first
// occurrence of any given value is present.
parcelHelpers.export(exports, "uniq", ()=>uniq);
function makeRangeDescription(quantity, limit) {
    const desc = [];
    const truncated = quantity > limit;
    if (truncated) desc.push("first", limit, "of");
    desc.push(quantity);
    return desc.join(" ");
}
function uniq(as) {
    const set = new Set();
    return as.filter((a)=>{
        if (set.has(a)) return false;
        set.add(a);
        return true;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["kp1yZ"], "kp1yZ", "parcelRequire85a9")

//# sourceMappingURL=index.c12839a0.js.map
